import { Link } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { toast } from "sonner";
import { Zap } from "lucide-react";

export default function ProductCard({ product }) {
  const { addItem } = useCart();
  const isB2B = product.marketplace === "b2b";

  const handleAdd = (e) => {
    e.preventDefault();
    addItem(product);
    toast.success("Added to cart", { description: product.name });
  };

  return (
    <Link to={`/product/${product.product_id}`} data-testid={`product-card-${product.product_id}`} className="nx-card group flex flex-col h-full">
      <div className="relative aspect-square overflow-hidden bg-slate-100">
        <img src={product.image} alt={product.name} loading="lazy"
             className="w-full h-full object-cover"
             style={{ transition: "transform 0.4s ease" }}
             onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.05)"}
             onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"} />
        {product.flash_sale && (
          <span className="absolute top-2 left-2 nx-tag bg-[#A3E635] text-emerald-950 border-emerald-900">
            <Zap size={10} /> -{product.discount}%
          </span>
        )}
        {isB2B && (
          <span className="absolute top-2 right-2 nx-tag bg-blue-700 text-white border-blue-900">B2B</span>
        )}
      </div>
      <div className="p-4 flex flex-col flex-1 gap-2">
        <span className="mono text-[10px] text-slate-500">{product.category}</span>
        <h3 className="text-sm font-bold line-clamp-2 leading-snug min-h-[2.5rem]">{product.name}</h3>
        <div className="flex items-baseline gap-2 mt-auto">
          <span className="text-xl font-black tracking-tight">${product.price.toFixed(2)}</span>
          {isB2B && <span className="mono text-[10px] text-slate-500">MOQ: {product.moq}</span>}
        </div>
        <button
          onClick={handleAdd}
          data-testid={`add-to-cart-${product.product_id}`}
          className="mt-1 w-full py-2 text-xs mono font-bold bg-slate-900 text-white hover:bg-blue-700"
          style={{ transition: "background-color 0.2s ease" }}
        >
          ADD/TO/CART
        </button>
      </div>
    </Link>
  );
}
